import { useState } from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import AppointmentFormFields from "./AppointmentFormFields";

// ---- Combined Form ----
function AppointmentForm({
  formik,
  premises,
  premisesID,
  setCustomFields,
  setStepperLevel,
  setDepartments,
}) {
  const [initialValues, setInitialValues] = useState({
    premises: premisesID || "",
    officer: "",
    department: "",
    departmentID: "",
    subDepartment: "",
    date: new Date().toString(),
    time: [],
    PurposeVisit: "",
    reason: "",
  });

  // ---- Validation Schema ----
  const validationSchema = Yup.object().shape({
    premises: Yup.string().required("Premises is required"),
    officer: Yup.string().required("Officer is required"),
    subDepartment: Yup.string().required("Sub-department is required"),
    date: Yup.date().required("Date is required"),
    time: Yup.array().min(1, "Time is required"),
    PurposeVisit: Yup.string().required("Purpose of Visit is required"),
    reason: Yup.string().when("PurposeVisit", {
      is: "other",
      then: Yup.string().required("Reason is required"),
      otherwise: Yup.string(),
    }),
  });

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      enableReinitialize
      onSubmit={(formData) => {
        formik.setValues((prev) => ({
          ...prev,
          ...formData,
        }));
        setStepperLevel(1);
      }}
    >
      {(formikProps) => {
        return (
          <AppointmentFormFields
            formikProps={formikProps}
            premises={premises}
            premisesID={premisesID}
            setCustomFields={setCustomFields}
            setStepperLevel={setStepperLevel}
            setDepartments={setDepartments}
          />
        );
      }}
    </Formik>
  );
}

export default AppointmentForm;
